import React from 'react';
import { PiFacebookLogo, PiInstagramLogo, PiTiktokLogo, PiWhatsappLogo } from 'react-icons/pi';
import { RiTwitterXLine } from 'react-icons/ri';

export const SOCIAL_LINKS = [
  { label: 'Instagram', href: 'https://www.instagram.com/rooldrive', icon: PiInstagramLogo },
  { label: 'TikTok', href: 'https://www.tiktok.com/@rooldrive', icon: PiTiktokLogo },
  { label: 'Facebook', href: 'https://www.facebook.com/profile.php?id=61564904366158', icon: PiFacebookLogo },
  { label: 'X', href: 'https://x.com/rooldrive', icon: RiTwitterXLine },
  { label: 'WhatsApp', href: 'https://api.whatsapp.com/send?phone=19292315951', icon: PiWhatsappLogo },
];

// Round icon buttons (footer), or labelled pills with `labels`.
export default function SocialLinks({ labels = false, className = '' }) {
  return (
    <ul className={`lx-social${labels ? ' lx-social--labels' : ''} ${className}`.trim()}>
      {SOCIAL_LINKS.map(({ label, href, icon: Icon }) => (
        <li key={label}>
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={labels ? undefined : `RoolDrive on ${label}`}
            title={labels ? undefined : label}
          >
            <Icon aria-hidden />
            {labels && <span>{label}</span>}
          </a>
        </li>
      ))}
    </ul>
  );
}
